<template>
  <button
    :class="{ 'FilterHeading--selected': props.selected, 'FilterHeading--with-desktop-title': props.desktopTitle }"
  >
    <span
      v-if="props.title"
      class="FilterHeading__btn"
    >
      <span class="FilterHeading__btn-text">{{ props.title }}</span>
      <span
        v-if="props.desktopTitle"
        class="FilterHeading__btn-text FilterHeading__btn-text--desktop"
      >
        {{ props.desktopTitle }}
      </span>
      <VisionIcon
        v-if="props.icon"
        icon="filter"
        colour="black"
        size="x-small"
      />
      <FilterPlusMinusIcon
        v-else
        :active="props.selected"
      />
    </span>
  </button>
</template>

<script setup lang="ts">
interface FilterHeadingProps {
  title: string
  desktopTitle?: string
  selected: boolean
  icon?: string
  groupValue?: string
  tracking?: boolean
}

const { $track } = useNuxtApp()

const props = withDefaults(defineProps<FilterHeadingProps>(), {
  tracking: true,
  icon: '',
  groupValue: '',
  desktopTitle: ''
})

watch(() => props.selected, async (newValue) => {
  if (props.tracking && newValue) {
    await $track.global.linkClicked({
      linkText: props.title,
      interactionSection: props.groupValue,
      interactionCategory: 'Opened filter option'
    })
  }
})
</script>

<style lang="postcss" scoped>
.FilterHeading__btn {
  @apply heading-3 md:text-sm md:font-bold py-5 flex items-center gap-x-2;

  @screen xl {
    @apply heading-4;
  }
}

.FilterHeading--with-desktop-title {
  .FilterHeading__btn-text {
    @apply lgMax:block lg:hidden;
  }

  .FilterHeading__btn-text--desktop {
    @apply lgMax:hidden lg:block;
  }
}

.FilterHeading__btn-text {
  @apply text-off-black order-2 whitespace-nowrap lg:order-1;
}
</style>
